// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 7329 ? "88a4ce8c" : chunkId) + "." + {"2430":"060e85fb209e5444","4374":"71a93ca577597dcd","7329":"bbb5535b88efded0"}[chunkId] + ".js";
};